var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStichingFabricSvgrepoCom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    x: 222.046,
    y: 32.941,
    style: {
      fill: "#FFBE75"
    },
    width: 71.536,
    height: 37.508
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#9DA6BA"
    },
    points: "500.554,97.54 500.554,191.773 453.249,191.773 453.249,110.405 453.249,97.54 "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11.446,
    y: 427.931,
    style: {
      fill: "#FFBE75"
    },
    width: 441.804,
    height: 51.128
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F1DCBD"
    },
    d: "M117.891,70.448h104.156h71.536h85.808h33.902c22.067,0,39.957,17.89,39.957,39.957v81.367v170.541 v65.618H11.446v-65.618h45.783h247.799l-22.891-175.119H120.18l-11.446,87.56H57.228H11.446v-87.56v-22.891 c0-51.838,42.017-93.855,93.855-93.855L117.891,70.448L117.891,70.448z M412.045,158.866c0-18.038-14.616-32.655-32.655-32.655 c-18.027,0-32.643,14.616-32.643,32.655c0,18.027,14.616,32.643,32.643,32.643C397.429,191.509,412.045,176.893,412.045,158.866z  M412.045,326.832c0-18.027-14.616-32.655-32.655-32.655c-18.027,0-32.643,14.628-32.643,32.655 c0,18.027,14.616,32.655,32.643,32.655C397.429,359.486,412.045,344.859,412.045,326.832z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFBE75"
    },
    d: "M379.39,126.212c18.038,0,32.655,14.616,32.655,32.655c0,18.027-14.616,32.643-32.655,32.643 c-18.027,0-32.643-14.616-32.643-32.643C346.747,140.828,361.363,126.212,379.39,126.212z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFBE75"
    },
    d: "M379.39,294.177c18.038,0,32.655,14.628,32.655,32.655c0,18.027-14.616,32.655-32.655,32.655 c-18.027,0-32.643-14.628-32.643-32.655C346.747,308.805,361.363,294.177,379.39,294.177z"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M379.39,370.932c24.318,0,44.1-19.783,44.1-44.1c0-24.316-19.783-44.099-44.1-44.099c-24.31,0-44.089,19.783-44.089,44.099 C335.301,351.149,355.08,370.932,379.39,370.932z M379.39,305.624c11.695,0,21.209,9.515,21.209,21.208 c0,11.695-9.515,21.209-21.209,21.209c-11.688,0-21.197-9.515-21.197-21.209C358.193,315.138,367.702,305.624,379.39,305.624z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M379.39,202.955c24.318,0,44.1-19.778,44.1-44.09c0-24.316-19.783-44.099-44.1-44.099c-24.31,0-44.089,19.783-44.089,44.099 C335.301,183.177,355.08,202.955,379.39,202.955z M379.39,137.658c11.695,0,21.209,9.515,21.209,21.208 c0,11.688-9.515,21.199-21.209,21.199c-11.688,0-21.197-9.51-21.197-21.199C358.193,147.172,367.702,137.658,379.39,137.658z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M500.554,86.094h-41.985c-8.687-16.114-25.723-27.092-45.277-27.092h-22.456V37.256c0-6.32-5.125-11.446-11.446-11.446 s-11.446,5.125-11.446,11.446v21.747h-62.917V32.941c0-6.32-5.125-11.446-11.446-11.446h-71.536c-6.32,0-11.446,5.125-11.446,11.446 v26.062H105.3C47.238,59.003,0,106.24,0,164.303v110.451c0,6.32,5.125,11.446,11.446,11.446h34.337v64.668H11.446 C5.125,350.868,0,355.993,0,362.313v116.746c0,6.32,5.125,11.446,11.446,11.446h441.804c6.32,0,11.446-5.125,11.446-11.446V203.218 h35.859c6.32,0,11.446-5.125,11.446-11.446V97.54C512,91.219,506.876,86.094,500.554,86.094z M233.492,44.386h48.644v14.616h-48.644 V44.386z M68.674,286.199h40.06c5.747,0,10.604-4.264,11.35-9.962l10.143-77.597h141.861l19.899,152.228H68.674V286.199z  M305.028,373.759c3.294,0,6.429-1.419,8.603-3.895s3.174-5.767,2.747-9.034l-22.891-175.119c-0.745-5.699-5.603-9.962-11.35-9.962 H120.18c-5.747,0-10.604,4.264-11.35,9.962l-10.143,77.597H22.891v-99.005c0-45.441,36.968-82.409,82.409-82.409h1.145v27.47 c0,6.32,5.125,11.446,11.446,11.446c6.32,0,11.446-5.125,11.446-11.446v-27.47h92.71h71.536h119.71 c15.721,0,28.511,12.791,28.511,28.511v81.367v224.713H22.891v-42.727L305.028,373.759L305.028,373.759z M22.891,467.614v-28.237 h418.912v28.237H22.891z M489.109,180.327h-24.414v-71.341h24.414V180.327z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M117.891,134.35c-6.32,0-11.446,5.125-11.446,11.446v5.151c0,6.32,5.125,11.446,11.446,11.446 c6.32,0,11.446-5.125,11.446-11.446v-5.151C129.336,139.474,124.211,134.35,117.891,134.35z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStichingFabricSvgrepoCom);
export default __webpack_public_path__ + "static/media/stiching-fabric-svgrepo-com.aac428c0f743b2ca843ea9bce9823bd9.svg";
export { ForwardRef as ReactComponent };